import mergeMasterStagingData from './mergeMasterStagingData';

export default function hasAnyModifiedValues(data) {
  return data
    .map(mergeMasterStagingData)
    .some(record => !!record.edited && !!record.edited.length);
}
